import { atom } from "recoil";

export const helpState = atom({
  key: 'showHelp',
  default: 0,
});

export const overlayState = atom({
  key: 'overlay',
  default: false,
});

export const popoverState = atom<string | null>({
  key: 'popover',
  default: null,
});

export const spinnerState = atom({
  key: 'spinner',
  default: {
    spinners: [] as string[], // Array of active spinner names
    opacity: false, // Opacity state
  },
});

export const spinnerLiteState = atom<number>({
  key: 'spinnerLite',
  default: 0,
});

export const shimmerLiteState = atom<string[]>({
  key: 'shimmerLite',
  default: [],
});

export const checkboxState = atom<{ MBP: boolean; spotlight: boolean; poimarker: boolean; adjacency: boolean; subregionBoundaries: boolean, catchments: boolean }>({
  key: 'checkboxState',
  default: {
    MBP: true,
    spotlight: true,
    poimarker: localStorage.getItem('poimarker') ? (localStorage.getItem('poimarker')=="true") : true,
    adjacency: (localStorage.getItem('adjacency')=="true") ? true : false,
    subregionBoundaries: (localStorage.getItem('subregionBoundaries')=="true") ? true : false,
    catchments: (localStorage.getItem('catchments')=="true") ? true : false,
  },
});

export const selAggLayerState = atom<any>({
  key: 'selAggLayerState',
  default: null,
});

export const showMapColorState = atom<boolean>({
  key: 'showMapColorState',
  default: true
});

export const showDrawerState = atom<boolean>({
  key: 'showDrawerState',
  default: false
});

export const recommendedRegionsState = atom<any>({
  key: 'recommendedRegionsState',
  default: {
    geoId: 1,
    type:[],
    metric_type:[],
    currency:"INR",
    category:[],
    subcategory:[],
    filters:[],
    mbpdata: [],
    poigrowthyear:5 
  }
});

export const selectedYearState = atom<any>({
  key:'selectedYearState',
  default: 5
})

export const topFiveRegionsState = atom<any[]>({
  key: 'topFiveRegionsState',
  default: []
})

export const markerCarouselState = atom<{
  markers: Array<{ type: 'mbp' | 'poi' | 'region'; data: any }>;
  currentIndex: number;
} | null>({
  key: 'markerCarouselState',
  default: null,
});

export const collisionRadiusKmState = atom<number | null>({
  key: 'collisionRadiusKmState',
  default: null,
});

export const hexLoadingState = atom<{
  loading: boolean;
  firstChunkReceived: boolean;
  progress: number;
}>({
  key: 'hexLoadingState',
  default: { loading: false, firstChunkReceived: false, progress: 0 },
});

export const isCatchmentAvailableState = atom<boolean>({
  key: 'isCatchmentAvailableState',
  default: true,
});